import * as React from 'react';
import { Context } from './Context';
export var useSession = function () {
    var session = React.useContext(Context);
    if (!session) {
        throw new Error('@lendi/lala-react: Please setup <SessionProvider/> in an ancestor component of the component using useSession().');
    }
    return session;
};
//# sourceMappingURL=useSession.js.map